import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ColourReferenceService extends BaseReferenceService {
  constructor() {
    super('ColourReference');
  }
}
